import { Location, NgClass } from "@angular/common";
import {
  Component,
  inject,
  input,
  ChangeDetectorRef,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { CsIconModule } from "@components/icon";
import { EventLoggerService } from "@services/event-logger-service";

@Component({
  selector: "app-floating-video-panel",
  imports: [NgClass, CsIconModule],
  templateUrl: "./floating-video-panel.component.html",
  styles: ":host { @apply tw-block; }",
})
export class FloatingVideoPanelComponent implements OnInit, OnDestroy {
  url = input<string>();
  eventloggerService: EventLoggerService = inject(EventLoggerService);
  private readonly location = inject(Location);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  isFullScreen: boolean = false;
  private readonly fullScreenStateKey = "floating-video-fullscreen";

  ngOnInit() {
    // Listen for browser back button
    this.location.onUrlChange(() => {
      if (this.isFullScreen) {
        this.exitFullScreen();
        // Force change detection to update the view
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    if (this.isFullScreen) {
      this.location.back();
    }
  }

  toggleMute(videoElement: HTMLVideoElement) {
    videoElement.muted = !videoElement.muted;
    if (videoElement.muted) {
      this.eventloggerService.cleverTapEvent(
        "click",
        JSON.stringify({ name: "floating_video_mute" })
      );
    } else {
      this.eventloggerService.cleverTapEvent(
        "click",
        JSON.stringify({ name: "floating_video_unmute" })
      );
    }
  }

  onMetadataLoaded(videoElement: HTMLVideoElement) {
    videoElement.muted = true;
    videoElement.autoplay = true;
  }

  closeVideo() {
    this.eventloggerService.cleverTapEvent(
      "click",
      JSON.stringify({ name: "floating_video_cross" })
    );
  }

  toggleFullScreen() {
    if (!this.isFullScreen) {
      this.enterFullScreen();
    } else {
      this.exitFullScreen();
    }
  }

  private enterFullScreen() {
    try {
      this.isFullScreen = true;
      history.pushState({ [this.fullScreenStateKey]: true }, "");
      this.eventloggerService.cleverTapEvent(
        "click",
        JSON.stringify({ name: "floating_video_fullscreen" })
      );
    } catch (e) {
      console.log(e);
    }
  }

  private exitFullScreen() {
    this.isFullScreen = false;
    this.eventloggerService.cleverTapEvent(
      "click",
      JSON.stringify({ name: "floating_video_minimize" })
    );
  }

  onVideoError(event: Event) {
    const error = (event.target as HTMLVideoElement).error;
    console.error("Video error:", error);
  }

  restartVideo(videoElement: HTMLVideoElement) {
    if (!videoElement) return;
    videoElement.currentTime = 0;
    videoElement.pause();

    videoElement.play();
  }
}
